// extracted by mini-css-extract-plugin
export var header = "_eo-0";